import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';
import { FaSearch, FaFileInvoice, FaUserMd, FaArrowRight } from 'react-icons/fa';

const services = [
	{
		icon: <FaSearch />,
		title: 'Find a Specialist',
		description: 'Search by specialty, view doctor profiles, and choose the right fit for your needs — all in minutes.',
	},
	{
		icon: <FaFileInvoice />,
		title: 'Get Your Invoice',
		description: 'Once you book, we coordinate with your doctor and send your invoice via email and WhatsApp before your visit.',
	},
	{
		icon: <FaUserMd />,
		title: 'See Your Doctor',
		description: 'Attend your confirmed appointment with a verified, experienced specialist. Your health is in good hands.',
	},
];

const Service = () => {
	return (
		<section className="services-section">
			<div className="container">
				<div className="services-header text-center">
					<span className="services-label">WHAT WE OFFER</span>
					<h2>Connecting you to the right specialist</h2>
					<p className="services-lead">
						From your first search to your confirmed appointment, we handle every step so you can focus on your health.
					</p>
				</div>
				<div className="row g-4">
					{services.map((item, index) => (
						<div className="col-lg-4 col-md-6" key={index}>
							<div className="service-card">
								<div className="service-card__icon">{item.icon}</div>
								<h3 className="service-card__title">{item.title}</h3>
								<p className="service-card__text">{item.description}</p>
							</div>
						</div>
					))}
				</div>
				<div className="text-center" style={{ marginTop: '2.5rem' }}>
					<Link to="/doctors" className="service-cta">
						View all specialists <FaArrowRight className="ms-2" />
					</Link>
				</div>
			</div>
		</section>
	);
};

export default Service;
